import { Injectable, Type } from '@angular/core';
import { IDisposable, IEmitable } from './types';
import { EventBusPipe } from './frm-eventpipe';
import { Subject } from 'rxjs';

@Injectable()
export class FrmEventBus implements IEmitable {

    public eventMap: Map<string, Array<EventBusPipe>>;

    constructor() {
        this.eventMap = new Map<string, Array<EventBusPipe>>();
    }


    // 发送事件，通知订阅者接收消息。
    post(tokenValue: string, eventArgs: any): void {
        let eventPipeList = this.eventMap.get(tokenValue);
        if (!eventPipeList) {
            eventPipeList = new Array<EventBusPipe>();
            this.eventMap.set(tokenValue, eventPipeList);
        }
        let eventPipe = eventPipeList.find(item => item.examByTargetToken(tokenValue));
        if (!eventPipe) {
            eventPipe = new EventBusPipe(tokenValue, eventPipeList, null);
        }
        for (const eventPipeDetail of eventPipeList) {
            if (eventPipeDetail.matchEmitterToken(tokenValue)) {
                eventPipeDetail.post(eventArgs);
            }
        }
    }

    initialPipe(token: string, sub: Subject<any>) {
        let pipes = this.eventMap.get(token);
        if (!pipes) {
            pipes = new Array<EventBusPipe>();
            this.eventMap.set(token, pipes);
        }
        let eventPipe = pipes.find(item => item.examByTargetToken(token));
        if (!eventPipe) {
            eventPipe = new EventBusPipe(token, pipes, sub);
        }
    }

    // 订阅事件
    on(tokenValue: string, handler: (value: any) => void): IDisposable {
        const pipe = this.getEventPipe(tokenValue);
        if (pipe) {
            return pipe.subscribe(handler);
        }
    }


    unSubscribe(tokenValue: string) {
        const pipe = this.getEventPipe(tokenValue);
        if (pipe) {
            pipe.unSubscribe();
        }
    }

    /** 订阅事件，并记录订阅者唯一标识 */
    onWithObkey(tokenValue: string, observerKey: string, handler: (value: any) => void): IDisposable {
        const pipe = this.getEventPipe(tokenValue);
        if (pipe) {
            return pipe.subscribeWithObkey(observerKey, handler);
        }
    }

    unSubscribeWithObKey(tokenValue: string, observerKey: string) {
        const pipe = this.getEventPipe(tokenValue);
        if (!!pipe) {
            pipe.unSubscribeWithObkey(observerKey);
        }
    }

    // 订阅一次。接收到一次消息之后自动取消订阅
    once(tokenValue: string, handler: (value: any) => void): IDisposable {
        const pipe = this.getEventPipe(tokenValue);
        if (pipe) {
            const res = pipe.subscribeOnce(handler);
            return res;
        }
    }

    clearSubject(tokenValue: string) {
        const pipe = this.getEventPipe(tokenValue);
        if (!!pipe) {
            pipe.complete();
            this.eventMap.set(tokenValue, null);
        }
    }

    private getEventPipe(tokenValue: string): EventBusPipe {
        const eventPipeList = this.eventMap.get(tokenValue);
        if (!eventPipeList) {
            return null;
        }
        const eventPipe = eventPipeList.find(item => item.examByTargetToken(tokenValue));
        return eventPipe as EventBusPipe;
    }
}
